import { render, staticRenderFns } from "./modal-user-base-info-data.vue?vue&type=template&id=2b9e4581&scoped=true&"
import script from "./modal-user-base-info-data.vue?vue&type=script&lang=js&"
export * from "./modal-user-base-info-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9e4581",
  null
  
)

export default component.exports